export default "__VITE_ASSET__1jyCxnjP__"